module.exports = __webpack_public_path__ + "img/12-black-diamond.eccee53f.png";